import React from 'react'
import '../Styles/Questions.css'

const QuestionSection = () => {
    return (
        <div className='question-container'>
             <div className="text-box">
                <h2 className="heading">
                    What Would You Like to Know?
                </h2>
                <p className="text">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, sit quia magni exercitationem officiis id.
                </p>
                <div className="cta">
                   Ask Questions
                </div>
            </div>
        </div>
    )
}

export default QuestionSection
